import {FeeScheduleDataModel} from '../../../models/fee-schedule/fee-schedule-data.model';

export class FeeScheduleListViewDataModel extends FeeScheduleDataModel {
  Hovered: boolean;
  Editable: boolean;
  OrganizationName: string;
}
